import { PRIVATE_ROUTE_SEGMENTS } from '~/constants/privateRouteSegments'
import { getFirstPathSegment } from '~/utils/router'

/**
 * Indique si la route exige d'être connecté (middleware `auth` ou espace compte).
 * @param {string} path - Chemin interne (`fullPath` ou `path` seul).
 * @returns {boolean} `true` si la page est privée.
 */
export function isAuthRequiredPath(path: string): boolean {
  const pathOnly: string = path.split('?')[0]?.split('#')[0] ?? '/'
  if (pathOnly === '/' || pathOnly === '/en' || pathOnly === '/es') return false
  const first: string | null = getFirstPathSegment(pathOnly)
  if (first === null) return false
  return PRIVATE_ROUTE_SEGMENTS.has(first.toLowerCase())
}
